import { Controller } from "@hotwired/stimulus"

// Apre/chiude il pannello dell'assistente accanto al canvas e tiene la
// conversazione ancorata in fondo quando arrivano messaggi via Turbo Stream.
export default class extends Controller {
  static targets = ["panel", "scroller", "toggle"]

  connect() {
    // Il canvas Excalidraw calcola le proprie dimensioni sull'elemento: dopo
    // ogni apertura/chiusura va avvisato che lo spazio è cambiato.
    this.observer = new MutationObserver(() => this.scrollToBottom())
    if (this.hasScrollerTarget) {
      this.observer.observe(this.scrollerTarget, { childList: true, subtree: true })
    }
  }

  disconnect() {
    this.observer?.disconnect()
  }

  toggle() {
    const hidden = this.panelTarget.classList.toggle("hidden")
    this.panelTarget.classList.toggle("flex", !hidden)
    this.toggleTarget?.classList.toggle("text-primary", !hidden)

    window.dispatchEvent(new Event("resize"))
    if (!hidden) {
      this.scrollToBottom()
      this.element.querySelector("[data-whiteboard-chat-target='input']")?.focus()
    }
  }

  scrollToBottom() {
    if (!this.hasScrollerTarget) return
    this.scrollerTarget.scrollTop = this.scrollerTarget.scrollHeight
  }
}
